import React, { useState, useEffect } from 'react';
import GridConfirmList from './GridConfirmList';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { getConfirmList } from '../../../redux/slices/approval';
import { APPROVAL_VIEW_MODES } from '../../../constants';

const ConfirmListGrid = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { isLoading, confirmList, confirmCondition, selectedViewMode } = useSelector((state: RootState) => state.approval);
  const { adminPowerUsers } = useSelector((state: RootState) => state.user);
  const { steelMaker, businessType, steelCategory } = useSelector((state: RootState) => state.options);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // /**
  //  * ステータスが変わったら一覧を再取得する
  //  */
  useEffect(() => {
    if (confirmCondition) {
      dispatch(getConfirmList());
    } else {
      // do nothing
    }
  }, [confirmCondition?.conditionStatus]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      {selectedViewMode === APPROVAL_VIEW_MODES.CONFIRM && (
        <GridConfirmList isLoading={isLoading} confirmList={confirmList} steelMaker={steelMaker} businessType={businessType} steelCategory={steelCategory} adminPowerUsers={adminPowerUsers} />
      )}
    </>
  );
};

export default ConfirmListGrid;
